import * as React from 'react';
import * as PropTypes from 'prop-types';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import { trackInteraction, LISTING_TYPE } from '@reverbdotcom/commons/dist/tracker';
import BumpModal from './bump_modal';
import ProductPageBump from './product_page_bump';

class BumpDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bid: this.props.bid,
      selectedBid: this.props.bid,
      error: false,
      didBidChange: false,
      deleted: false,
      showMobileSlider: false,
    };

    this.toggleSlider = this.toggleSlider.bind(this);
    this.updateBid = this.updateBid.bind(this);
    this.handleBidChange = this.handleBidChange.bind(this);
    this.changeDismiss = this.changeDismiss.bind(this);
  }

  trackInteraction(newBid) {
    trackInteraction({
      componentName: 'ProductPageBump',
      type: LISTING_TYPE,
      entityId: this.props.product.id,
      context: { bumpPercentage: newBid },
    });
  }

  get displayBumpBanner() {
    return this.props.product.live && !this.props.product.soldWithBump;
  }

  get displayBumpModal() {
    if (
      this.props.product.bumped ||
      !this.props.product.directCheckout
    ) { return false; }

    return this.props.product.preview;
  }

  setBid(newBid) {
    APIRequest.post('/bump/bids/', {
      bump_bids: {
        product_id: this.props.product.id,
        bid: newBid,
      },
    })
      .then(() => {
        this.setState({
          bid: newBid, selectedBid: newBid, error: false, didBidChange: true, deleted: false,
        });
      })
      .fail(() => this.setState({ error: true, selectedBid: this.state.bid }));
  }

  deleteBid() {
    APIRequest.destroy(`/bump/bids/${this.props.product.id}`)
      .then(() => {
        this.setState({
          bid: null, selectedBid: null, error: false, deleted: true, didBidChange: true,
        });
      })
      .fail(() => {
        this.setState({ error: true, selectedBid: this.state.bid });
      });
  }

  updateBid(newBid) {
    this.trackInteraction(newBid);
    if (newBid === 0.0) {
      this.deleteBid();
    } else {
      this.setBid(newBid);
    }
  }

  toggleSlider() {
    this.setState({ showMobileSlider: !this.state.showMobileSlider });
  }

  handleBidChange(newBid) {
    this.setState({ selectedBid: newBid });
  }

  changeDismiss() {
    this.setState({ didBidChange: false });
  }

  productPageBump() {
    return (
      <ProductPageBump
        sliderToggle={this.toggleSlider}
        productId={this.props.product.id}
        updateBid={this.updateBid}
        changeDismiss={this.changeDismiss}
        showMobileSlider={this.state.showMobileSlider}
        selectedBid={this.state.selectedBid}
        deleted={this.state.deleted}
        onBidChange={this.handleBidChange}
        didBidChange={this.state.didBidChange}
        bid={this.state.bid}
        adminBid={this.props.adminBid}
        bidTiers={this.props.bidTiers}
        tierIncrement={this.props.tierIncrement}
        exampleBumpPercent={this.props.exampleBumpPercent}
        listingPrice={this.props.listingPrice}
        shippingPrice={this.props.shippingPrice}
        exampleSpend={this.props.exampleSpend}
        impressions={this.props.impressions}
        salesCount={this.props.salesCount}
        salesSpent={this.props.salesSpent}
        salesRevenue={this.props.salesRevenue}
        hasComparisonShoppingPage={this.props.hasComparisonShoppingPage}
        isNewCondition={this.props.isNewCondition}
        error={this.state.error}
      />
    );
  }

  renderBumpBanner() {
    return this.productPageBump();
  }

  renderBumpModal() {
    return (
      <BumpModal modalOpen>
        {this.productPageBump()}
      </BumpModal>
    );
  }

  render() {
    if (!this.props.product) return null;

    return (
      <div>
        {this.displayBumpModal && this.renderBumpModal()}
        {this.displayBumpBanner && this.renderBumpBanner()}
      </div>
    );
  }
}

const productPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  bumped: PropTypes.bool.isRequired,
  soldWithBump: PropTypes.bool.isRequired,
  live: PropTypes.bool.isRequired,
  directCheckout: PropTypes.bool.isRequired,
  preview: PropTypes.bool.isRequired,
});

const adminBidPropType = PropTypes.shape({
  bid: PropTypes.number.isRequired,
  expiresAt: PropTypes.string,
});

BumpDisplay.propTypes = {
  product: productPropType.isRequired,
  bid: PropTypes.number.isRequired,
  adminBid: adminBidPropType,
  bidTiers: PropTypes.array.isRequired,
  tierIncrement: PropTypes.number.isRequired,
  exampleBumpPercent: PropTypes.string,
  listingPrice: PropTypes.string,
  shippingPrice: PropTypes.string,
  exampleSpend: PropTypes.string,
  impressions: PropTypes.number,
  salesCount: PropTypes.number,
  salesSpent: PropTypes.string,
  salesRevenue: PropTypes.string,
  hasComparisonShoppingPage: PropTypes.bool,
  isNewCondition: PropTypes.bool.isRequired,
};

export default BumpDisplay;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_display.jsx